/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceAddLocaleNameSpaceResponse model module.
 * @module model/ServiceAddLocaleNameSpaceResponse
 * @version version not set
 */
export class ServiceAddLocaleNameSpaceResponse {
  /**
   * Constructs a new <code>ServiceAddLocaleNameSpaceResponse</code>.
   * @alias module:model/ServiceAddLocaleNameSpaceResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceAddLocaleNameSpaceResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceAddLocaleNameSpaceResponse} obj Optional instance to populate.
   * @return {module:model/ServiceAddLocaleNameSpaceResponse} The populated <code>ServiceAddLocaleNameSpaceResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceAddLocaleNameSpaceResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceAddLocaleNameSpaceResponse.prototype.state = undefined;


